<template>
  <div class="news-list">
    <div class="excellentCases" v-if="screenWidth > 540">
      <div class="baseContent">
        <div class="prev" v-if="screenWidth > 640">

          <!-- <el-button class="txlhover"> -->
          <img @click="arrowClick('prev')" src="@/assets/img/fanye-left.png" alt="" class="carousel-icon">
          <!-- </el-button> -->
          <!-- <i class="el-icon-back" @click="arrowClick('prev')"></i> -->
        </div>
        <div>
          <el-carousel :height="screenWidth > 540 ?'20rem':'12rem'" indicatorPosition="none" :indicator-position="false" arrow="never" :autoplay="false" ref="cardShow">
            <el-carousel-item v-for="(item, index) in foundationProjectList" :key="index">
              <div style="flex;gap: 2%;">
                <div style="width: 49%;float: left;overflow: hidden;border-radius: 1rem;height:20rem;">
                  <img :src="item.imgUrl" alt="" width="100%" :class="screenWidth > 540 ?'left-img':''" class="img-jijin" style="border-radius: 1rem;" @click="toJump(item.id)">
                </div>
                <div style="width: 49%;float: left;margin-left:1rem;">
                  <div style="width: 100%;display: flex;align-items: center;justify-content: left;" class="foundation-project-item-div">
                    <div>
                      <h3 :class="screenWidth>640?'text-max-2':'text-max-1'">{{ item.name }}</h3>
                      <div class="text-max-1" :style="{'margin-top': screenWidth>640?'0':'-0.5rem',}" style="line-height: 2;"  >
						{{item.content}}
                      </div>
                      <div :style="{'margin-top': screenWidth>640?'2rem':'0.5rem',}" class="look-more" @click="toJump(item.id)">
                        {{$t('ViewDetails')}} <i class="el-icon-right"></i>
                      </div>
                    </div>

                  </div>

                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>

        <div class="next" v-if="screenWidth > 640">
          <img src="@/assets/img/fanye-right.png" alt="" @click="arrowClick('next')" class="carousel-icon">
          <!-- <i class="el-icon-right" @click="arrowClick('next')"></i> -->
        </div>

      </div>
    </div>
    <div v-else style="margin: 0 2rem;overflow: hidden;" class="news-list-mini">
      <div style="margin-top: 2rem;border-radius: 0.5rem;" v-for="(item, index) in foundationProjectList" v-if="index < 3" :key="index" @click="toJump(item.id)">
        <div style="width: 100%;overflow: hidden;">
          <img :src="item.imgUrl" alt="" width="100%"  >
        </div>
        <div style="background: #FFFFFF;padding: 1rem;border-bottom-left-radius: 0.6rem;border-bottom-right-radius: 0.6rem;">
          <h2>{{ item.name }}</h2>
          <div style="font-size: 1.1rem;">
            {{ item.content }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapState
} from 'vuex'
export default {
  computed: {
    ...mapState(['screenWidth'])
  },
  props: {
    foundationProjectList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {};
  },
  mounted() {
    console.log("foundationProjectList", this.foundationProjectList);

  },
  methods: {
    arrowClick(type) {
      if (type === 'prev') {
        this.$refs.cardShow.prev();
      } else if (type === 'next') {
        this.$refs.cardShow.next();
      }
    },
    toJump(id) {
      this.$router.push({
        path: "/foundationProject/sectorList",
        query: {
          id: id,
		  fundId:2
        },
      });
    }

  },
};
</script>

<style scoped lang="less">
.text-max-1{
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.news-list-mini {
  margin-top: 1rem;
}
.excellentCases {
  width: 90%;
  margin: 0 5%;
  margin-top: 2rem;
  background: #fdfdfe;

  .baseContent {
    position: relative;

    .prev {
      position: absolute;
      left: -2.5rem;
      top: 50%;
    }

    .pre:hover .carousel-icon {
      content: url("../../../assets/img/fanye-left-hover.png");
    }

    .next {
      position: absolute;
      right: -2.5rem;
      top: 50%;
    }

    img {
      vertical-align: middle !important;
    }

    .el-carousel__container {
      height: 30rem;
    }
  }
}

.look-more {
  width: 6rem;
  padding: 0.5rem;
  background-color: #f8f8f8;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  border-radius: 1.5rem;
  cursor: pointer;
}

.news-abstract {
  overflow: hidden;
  line-height: 2rem;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

.carousel-icon {
  width: 2rem;
}

.prev:hover {
  img {
    content: url(../../../assets/img/fanye-left-hover.png);
  }
}

.next:hover {
  img {
    content: url(../../../assets/img/fanye-right-hover.png);
  }
}

.img-jijin{
  height: 100%;
}
.left-img {
  width: 100%;
  // margin-top: 0.5rem;

  img {
    vertical-align: middle;
  }
}

.left-img:hover {
  width: calc(100% + 4rem);
  height: 24rem;
}

.foundation-project-item-div {
  height: 16rem;
  object-fit: cover;
}
</style>